import { Link } from 'react-router-dom';
import { featuredManga } from '@/mocks/manga';

export default function FeaturedManga() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选推荐
            </h2>
            <p className="mt-2 text-sm text-foreground-500">编辑团队精心甄选，品质保证</p>
          </div>
          <Link
            to="/category/xuan-yi-jing-song"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-product-shop="">
          {featuredManga.slice(0, 4).map((manga) => (
            <Link
              key={manga.id}
              to={`/article/${manga.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-4">
                <img
                  src={manga.coverImage}
                  alt={manga.title}
                  title={`${manga.title} - 成人漫画推荐`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <span className="text-background-50 text-xs font-medium bg-primary-500/90 px-2 py-1 rounded">
                    {manga.rating} ★
                  </span>
                </div>
                {manga.status === '已完结' && (
                  <span className="absolute top-2 left-2 bg-accent-500 text-background-950 text-xs font-semibold px-2 py-0.5 rounded">
                    已完结
                  </span>
                )}
              </div>
              <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors">
                {manga.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{manga.author} · {manga.category}</p>
              <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">
                {manga.description.slice(0, 60)}...
              </p>
            </Link>
          ))}
        </div>

        <div className="mt-6 sm:hidden flex justify-center">
          <Link
            to="/category/xuan-yi-jing-song"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}